import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },

    floor: {
        show: true,
        title: i18n.t('message.floor'),
        corps: "Корпус",
        sortable: true,
        column: 'housing'
    },
    corps_id: {
        show: true,
        title: i18n.t('message.corps'),
        sortable: true,
        column: 'organization_id'
    },
    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
